export default __webpack_public_path__ + "static/media/folder_outline.815bb47b.svg";